<template>
  <div class="toast__mask">
    <div class="toast__content">
      <img v-if="closeTip" class="close" @click="close" src="@/assets/img/delete.png"
        srcset="@/assets/img/delete@2x.png 2x,@/assets/img/delete@3x.png 3x">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'toast',
  props: {
    closeTip: Boolean,
    closeEvent: Function
  },
  methods: {
    close () {
      this.closeEvent();
    }
  }

}
</script>

<style>
.toast__mask {
  position: fixed;
  z-index: 2000;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.8);
}
.toast__content {
  position: relative;
  padding: 0 15px 20px;
  width: 250px;
  /* height: 266px; */
  min-height: 194px;
  background-color: #fff;
  border-radius: 5px;
  text-align: center;
  box-sizing: border-box;
  z-index: 2002;
}
.close {
  position: absolute;
  top: -40px;
  right: 10px;
  z-index: 2001;
}
</style>